export enum Breakpoints {
  TABLET = 1024,
  NOTEBOOK = 1366,
  DESKTOP = 1600,
}
